import React, { Component } from 'react'

export default class Pricing extends Component {
  render() {
    return (
      <div className='Pricing'>
      <div className='Pdiv'>
        <h1>Register with our Base Plan</h1>
        <p>We give an online platform for your laundry at a convenient and minimal cost. With our secure and reliable platform, we help our customers for exponential growth.</p>
        
        <div className='PriceList'>
          <h1>Standard</h1>
          
          <div className='Features'>
            <ul>
              <li><span>No Customer Limits.</span></li>
              <li><span>Add Unlimited Services.</span></li>
              <li><span>Discount & Advance Payment Options.</span></li>
              <li><span>Payment Dues Management.</span></li>
              <li><span>Unlimited SMS Service for your Customers.</span></li>
              <li><span>Annual Reports & Statistics.</span></li>
            </ul>
          </div>
        
        
      
        <div className='Price'>
          <h2>₹12000/year</h2>
          <h1>₹15000/year</h1>
          <div className='F2'>
          <h3>Free</h3>
          <span>Setup & lifetime support</span>
          </div>
        </div>

        </div>
      </div>  
      </div>
    )
  }
}
